import React from 'react';
import { useMySubordinatesList } from './hooks/useMySubordinatesList';
import SharedFilters from '../../../components/SharedFilters';
import AppPagination from '../../../components/AppPagination';
import MySubordinatesSummaryCards from './components/MySubordinatesSummaryCards';
import MySubordinatesTable from './components/MySubordinatesTable';

export default function MySubordinatesListScreen() {
  const { state, actions } = useMySubordinatesList();

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            My Subordinates
          </h1>
          <p className="mt-1.5 text-xs text-on-surface-variant font-medium">
            Direct reporting hierarchy, subordinate roster, and team management
          </p>
        </div>

        {/* Status Toggle Capsule */}
        <div className="flex items-center gap-1.5 p-1 rounded-2xl bg-surface-container-high w-fit shadow-xs select-none">
          {state.statusOptions.map((tab) => {
            const isActive = state.statusFilter === tab.value;
            return (
              <button
                key={tab.value}
                type="button"
                onClick={() => actions.setStatusFilter(tab.value)}
                className={`px-5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer select-none ${
                  isActive
                    ? 'bg-primary text-on-primary shadow-sm'
                    : 'text-on-surface-variant hover:text-on-surface hover:bg-surface-container-highest/60'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </section>

      {/* Summary KPI Cards */}
      <MySubordinatesSummaryCards summary={state.summary} />

      {/* Shared Filters Component */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        showStatus={false}

        departmentFilter={state.departmentFilter}
        departmentOptions={state.departmentOptions}

        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setDepartmentFilter={actions.setDepartmentFilter}

        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}

        searchFieldOptions={state.searchFieldOptions}

        visibleAccordionFilters={[
          'department',
        ]}

        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
      />

      {/* Subordinates Table */}
      <section className="space-y-4">
        <MySubordinatesTable
          records={state.records}
          isLoading={state.isLoading}
          onResetFilters={actions.resetFilters}
        />

        {/* Table Footer with Pagination */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>
    </div>
  );
}
